export default __webpack_public_path__ + "static/google-play-badge-e1f42650a95aae797fb005c034a81f1c.png";